module.exports = __webpack_public_path__ + "img/writing_lessons.09a7e783.jpg";